import { Button } from 'src/core/components';
import { page } from 'src/locale';
import { hoc } from 'src/core/utils';
import { useTryZynProps } from '../../try-zyn.props';
import classNames from 'classnames';
import styles from './header.module.scss';

/**
 * <Header />
 */

const Header = hoc(useTryZynProps, ({ locale, handleScroll }) => (
  <div
    className={styles.header}
    style={{
      backgroundImage: `url(${page.header.imageMob}), ${page.header.backgroundMob}`
    }}
  >
    <div className={styles.container}>
      <div className={styles.textwrapper}>
        <h1
          className={styles.title}
          dangerouslySetInnerHTML={{
            __html: page.header.title[locale]
          }}
        />
        <p
          className={styles.text}
          dangerouslySetInnerHTML={{
            __html: page.header.text[locale]
          }}
        />
        <Button
          color='quaternary'
          className={styles.btn}
          onClick={() => handleScroll()}
        >
          {page.header.button[locale]}
        </Button>
      </div>
      <div className={styles.list_wrapper}>
        <div className={styles.container}>
          <h2 className={styles.howtitle}>{page.how.title[locale]}</h2>
          <ul className={styles.list}>
            <li className={classNames(styles.itemOne, styles.item)}>
              {page.how.item1[locale]}
            </li>
            <li className={classNames(styles.itemTwo, styles.item)}>
              {page.how.item2[locale]}
            </li>
            <li className={classNames(styles.itemThree, styles.item)}>
              {page.how.item3[locale]}
            </li>
            <li className={classNames(styles.itemFour, styles.item)}>
              {page.how.item4[locale]}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
));

export { Header };
